/**
 * ページナビ
 */
export default () => {
  const body = document.getElementsByTagName('body')[0];
  const siteNavigation = document.querySelector('.main-navigation');
  if (!siteNavigation) {
    return;
  }
  const spNavigation = document.querySelector('.sp-navigation');
  if (!spNavigation) {
    return;
  }
  const toggleButton = spNavigation.querySelector('.js-menuToggle');
  if (typeof toggleButton === 'undefined' || toggleButton === null) {
    return;
  }

  /**
   * focusの切替
   */
  const menu = siteNavigation.getElementsByTagName('ul')[0];
  if (!menu.classList.contains('nav-menu')) {
    menu.classList.add('nav-menu');
  }
  const menuLinks = menu.querySelectorAll('a');
  const spMenuLinks = spNavigation.querySelectorAll('a');

  const toggleFocus = (event) => {
    if (event.type === 'focus' || event.type === 'blur') {
      let self = this;
      while (!self.classList.contains('nav-menu')) {
        if (self.tagName.toLowerCase() === 'li') {
          self.classList.toggle('focus');
        }
        self = self.parentNode;
      }
      if (event.type === 'touchstart') {
        const menuItem = this.parentNode;
        event.preventDefault();
        menuItem.parentNode.children.forEach((link) => {
          if (menuItem !== link) {
            link.classList.remove('focus');
          }
        });
        menuItem.classList.toggle('focus');
      }
    }
  };

  menuLinks.forEach((link) => {
    link.addEventListener('touchstart', toggleFocus, false);
  });
  spMenuLinks.forEach((link) => {
    link.addEventListener('touchstart', toggleFocus, false);
  });

  /**
   * toggleボタンクリック
   */
  toggleButton.addEventListener('click', () => {
    spNavigation.classList.toggle('toggled');
    if (toggleButton.getAttribute('aria-expanded') === 'true') {
      toggleButton.setAttribute('aria-expanded', 'false');
      body.dataset.navState = 'close';
    } else {
      toggleButton.setAttribute('aria-expanded', 'true');
      body.dataset.navState = 'open';
    }
  });

  /**
   * PCサイズでスマホメニュー強制閉じる
   */
  const addMQListener = (mq, callback) => {
    if (mq.addEventListener) {
      mq.addEventListener('change', callback);
    } else {
      mq.addListener(callback);
    }
  };
  addMQListener(window.matchMedia('(min-width: 905px)'), (event) => {
    if (event.matches) {
      toggleButton.setAttribute('aria-expanded', 'false');
      body.dataset.navState = 'close';
    }
  });

  /**
   * SP用サブメニュー
   */
  const subMenuParents = spNavigation.querySelectorAll(
    '.menu-item-has-children',
  );
  if (!subMenuParents || subMenuParents.length === 0) {
    return;
  }
  subMenuParents.forEach((subMenuParent) => {
    const insertBtn = document.createElement('button');
    insertBtn.classList.add('submenu-toggle', 'js-subtoggle');
    insertBtn.insertAdjacentHTML('beforeend', '<span>サブメニュー開閉</span>');
    subMenuParent.appendChild(insertBtn);
    insertBtn.addEventListener('click', (event) => {
      const targetParent = event.target.parentNode;
      if (targetParent.dataset.subopen === 'open') {
        targetParent.dataset.subopen = 'close';
      } else {
        targetParent.dataset.subopen = 'open';
      }
    });
  });
};
